import type Metadata from './Metadata';
import type { Image3DPageData } from './Source';
import { ImageLikeSource, SourceType } from './Source';
import type { Pixel } from './Unit';
import type Unit from './Unit';

export type LyricsEntry = {
  type: 'lyrics' | 'break';
  tag: string;
  start: number;
};

export type LyricsRender = {
  text: string;
  x: number;
  onset: number;
};

export type LyricsRowData = {
  y: number;
  renders: LyricsRender[];
};

export type LyricsRenderConfig = {
  fontSize: number;
  letterSpacing: number;
  wordSpacing: number;
};

type LyricsData = {
  lyricsEntries: LyricsEntry[];
  pixelUnit: Unit<Pixel>;
  width: Pixel;
  height: Pixel;
  pages?: Image3DPageData[];
  metadata: Metadata;
  name?: string;
  source?: string;
  renderRows: LyricsRowData[];
  renderConfig: LyricsRenderConfig;
  isLinear: boolean;
};

export default class Lyrics extends ImageLikeSource implements Readonly<LyricsData> {
  readonly lyricsEntries: LyricsEntry[];

  readonly renderRows: LyricsRowData[];

  readonly renderConfig: LyricsRenderConfig;

  protected constructor(parsed: LyricsData) {
    super({
      type: SourceType.Lyrics,
      pixelUnit: parsed.pixelUnit,
      width: parsed.width,
      height: parsed.height,
      pages: parsed.pages,
      metadata: parsed.metadata,
      name: parsed.name,
      source: parsed.source,
      isLinear: false,
    });
    this.lyricsEntries = parsed.lyricsEntries;
    this.renderRows = parsed.renderRows;
    this.renderConfig = parsed.renderConfig;
  }

  scaled(scale: number): Lyrics {
    const data = { ...this };
    return new Lyrics({
      ...data,
      width: data.width * scale,
      pixelUnit: data.pixelUnit.getScaled(scale),
    });
  }
}
